<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">Participantes</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field id="teamuser_search" append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn id="teamUser_add_btn" color="primary" @click="create(false)" class="mb-4">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          :search="search"
          hide-actions
          :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
          class="elevation-1"
          :custom-filter="customizedFilter" style="word-break: break-all;">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.user.id_text+(props.item.connection_company_id ? (' ('+props.item.connection_company.id_text+')') : '')}}</td>
            <td>
              <v-checkbox
                v-model="props.item.manager"
                readonly class="mx-auto"
              ></v-checkbox>
            </td>
            <td align="center" style="min-width: 150px">
              <v-btn :id="'teamUser_edit_btn_'+props.index" icon class="mx-0" @click="beforeEdit(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn :id="'teamUser_delete_btn_'+props.index" icon class="mx-0" @click="dialogDelete(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-form v-model="valid" @keyup.native.esc="close" @keyup.native.ctrl.enter="save()" ref="form">
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <p-select-user v-if="view === 2" :needCompanyPlan="true" :disabled="loadingUsers" :loading="loadingUsers" ref="userIllis" v-model="selectedUsers" :multiple="true" :itemsNotShow="itemsNotShow" :rules="requiredManyRule('participante')" :label="translate('table.' + entity + '.field.user_id')" @input="changeUser"></p-select-user>
                </v-flex>
                <v-flex xs12>
                  <v-switch id="teamUser_manager"  :disabled="disableManager" :label="translate('table.' + entity + '.field.manager')" v-model="editedItem.manager"></v-switch>
                  <h5 v-if="disableManager" >Apenas participantes da própria empresa podem ser responsáveis.</h5>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="teamUser_save_btn" class="mx-0" color="primary darken-2" :loading="loading" @click.native="save()">Salvar</v-btn>
          <v-btn id="teamUser_close_btn" class="mx-0" @click.native="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import PConfirm from './../shared/PConfirm'
  import PSelectUser from './../shared/PSelectUser'

  /* eslint-disable no-extra-boolean-cast */
  export default {
    mixins: [crud, rules],
    components: {PConfirm, PSelectUser},
    data: () => ({
      entity: 'team_user',
      disableManager: false,
      loadingUsers: false,
      user_id: '',
      selectedUsers: [],
      items: [],
      users: []
    }),
    name: 'TeamUser',
    props: ['team'],
    created () {
      // se tiver para inserir um usuário foca no campo de usuário
      if (this.view === 2) {
        this.$nextTick(() => this.$refs.userIllis.focus())
      }
      this.items = this.team.users
      this.editedItem = {connection_id: '', connection_company_id: '', team_id: this.team.id, user: {}}
      this.defaultItem = {connection_id: '', connection_company_id: '', team_id: this.team.id, user: {}}
    },
    methods: {
      close (time = 0, viewAfterSave = null) {
        this.$refs.form.resetValidation()
        this.dialog = false
        this.disableManager = false
        setTimeout(() => {
          this.view = viewAfterSave || this.view.index
          Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.defaultItem)))
          this.loading = false
        }, time)
      },
      beforeCreate () {
        this.disableManager = false
        this.editedItem.manager = false
      },
      /* eslint-disable */
      beforeDelete (item) {
        if (item.manager === true || item.manager === 1) {
          let response = true
          this.items.map(function (user) {
            if ((user.manager === 1 || user.manager === true) && (user.id !== item.id)) {
              response = false
            }
          })
          if (response) {
            this.$store.commit('snackbar/change_values', {text: 'É requerido no mínimo um Responsável!', color: 'error', dialog: true})
            return false
          }
        }
      },
      save () {
        if ((this.$refs.form && !this.$refs.form.validate()) || (this.$refs.userIllis && !this.$refs.userIllis.validate())) {
          this.$store.commit('snackbar/change_values', {text: 'Por favor, corrija as validações antes de salvar!', color: 'error', dialog: true})
          return false
        }
        this.loading = true
        let _this = this
        this.$store.commit('loader/change_dialog', true)
        if (this.view === 2) {
          var usersToSave = this.selectedUsers
          this.loadingUsers = true
          usersToSave.forEach(function (user, index, array) {
              // Atribui os valores corretos para o user_id, connection_id e connection_company_id
              // _this.getValuesResponsible(user.id)
              _this.editedItem.user_id = user.user_id
              _this.editedItem.connection_id = user.connection_id
              // se a compania do usuário for diferente da do item, significa que o item é um usuário de outra empresa
              _this.editedItem.connection_company_id = (_this.$auth.user().company_id !== user.company_id ? user.company_id : null)
              _this.$http.post('api/' + _this.entity, _this.editedItem).then(
                res => {
                  _this.items.push(res.body)
                  // Emissão de evento para adição de detalhes
                  _this.$socket.emit('generalDetailsEvent', {
                    data: res.body,
                    details: 'users',
                    responseEvent: 'addSocketDetails',
                    room: `teams${_this.$auth.user().company_id}_${res.body.team_id}`
                  })
                  // Evento emitido para atualizar os detalhes da equipe para os usuários que estão na tela de consulta
                  _this.$socket.emit('generalDetailsEvent', {
                    data: res.body,
                    details: 'users',
                    responseEvent: 'addSocketItemDetails',
                    room: `teams${_this.$auth.user().company_id}`
                  })
                  _this.$store.commit('loader/change_dialog', false)
                  _this.$store.commit('snackbar/change_values', {
                    text: `Registro de ${_this.translate(`table.${_this.entity}.title`)[0]} incluído com sucesso!`,
                    color: 'success',
                    dialog: true})
                  if(usersToSave.length <= (index + 1)) {
                    // setTimeout insertido para dar tempo de zerar tirar os campos da lista de responsáveis antes que o usuário queira abrir
                    setTimeout(()=>{
                      _this.loading = false
                      _this.loadingUsers = false
                    }, 1500)
                  }
                }, err => {
                  _this.$store.commit('loader/change_dialog', false)
                  _this.$store.commit('snackbar/change_values', {
                    text: 'Não foi possível incluir o registro de ' + _this.translate('table.' + _this.entity + '.title')[0] +
                    ', reporte o erro.', color: 'error', dialog: true
                  })
                  if(usersToSave.length <= (index + 1)) {
                    setTimeout(()=>{
                      _this.loading = false
                      _this.loadingUsers = false
                    }, 1500)
                  }
                }
              )
            },
          )
          this.selectedUsers = []
        } else if (this.view === 3) {
          if (_this.editedItem.manager === false || _this.editedItem.manager === 0) {
            let response = true
            this.items.map(function (user) {
              if ((user.manager === 1 || user.manager === true) && (user.id !== _this.editedItem.id)) {
                response = false
              }
            })
            if (response) {
              this.$store.commit('snackbar/change_values', {text: 'É requerido no mínimo um Responsável!', color: 'error', dialog: true})
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              return false
            }
          }
          // Atribui os valores corretos para o user_id, connection_id e connection_company_id
          this.$http.put('api/' + this.entity + '/' + this.editedItem.id, this.editedItem).then(
            res => {
              Object.assign(this.items.find((val) => { return val.id === this.editedItem.id }) || {}, res.body)
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', {
                text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!', 
                color: 'success', 
                dialog: true
              })
              // Emissão de evento para edição de detalhes
              this.$socket.emit('generalDetailsEvent', {
                data: res.body,
                details: 'users',
                responseEvent: 'editSocketDetails',
                room: `teams${this.$auth.user().company_id}_${res.body.team_id}`,
              })
              // Evento emitido para atualizar os detalhes da equipe para os usuários que estão na tela de colsulta
              this.$socket.emit('generalDetailsEvent', {
                data: res.body,
                details: 'users',
                responseEvent: 'editSocketItemDetails',
                room: `teams${this.$auth.user().company_id}`,
              })
              // Enviando evento para mostrar alerta na tela do usuário que deixou de ser participante da equipe
              if (this.editedItem.user_id !== this.beforeEditedItem.user_id) {
                let item = {text: `Não é possível continuar editando esta equipe pois você não é mais um participante.`, user_id: this.beforeEditedItem.user_id, unlockRoom: `teams${this.$auth.user().company_id}_${this.editedItem.team_id}`}
                this.$socket.emit('generalEvent', {
                  data: item,
                  notBroadcast: true,
                  responseEvent: 'deleteSocketDetailUser',
                  room: `teams${this.$auth.user().company_id}_${this.editedItem.team_id}`
                })
              } else if (this.editedItem.manager !== this.beforeEditedItem.manager && (!this.editedItem.manager)) {
                let item = {text: `Não é possível continuar editando esta equipe pois você não é mais um administrador.`, user_id: this.editedItem.user_id, unlockRoom: `teams${this.$auth.user().company_id}_${this.editedItem.team_id}`}
                this.$socket.emit('generalEvent', {
                  data: item,
                  notBroadcast: true,
                  responseEvent: 'deleteSocketDetailUser',
                  room: `teams${this.$auth.user().company_id}_${this.editedItem.team_id}`
                })
              }
            },
            err => {
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível editar o registro de ' +
                this.translate('table.' + this.entity + '.title')[0] +
                ', reporte o erro.', color: 'error', dialog: true
              })
            }
          )
        }
        this.close()
      },
      changeUser (val) {
        this.disableManager = false
        if (val) {
          // Quando muda o usuário verifica se não tem algum com conexão, pois com conexão não pode ser responsável
          this.disableManager = val.some((user) => {
            return (user.company_id !== this.$auth.user().company_id)
          })
          this.disableManager ? this.editedItem.manager = false : this.editedItem.manager = true
        }
      },
      afterCreate () {
        this.$refs.form.reset()
        // verificar necessidade
        this.editedItem.manager = true
        this.$nextTick(() => this.$refs.userIllis.focus())
      },
      beforeEdit (props) {
        this.disableManager =  props.connection_id !== null
        this.editItem(props)
      },
      afterDelete (oldValues) {
        // Emissão de evento para exclusão de detalhes
        this.$socket.emit('generalDetailsEvent', {
          data: oldValues,
          details: 'users',
          responseEvent: 'deleteSocketDetails',
          room: `teams${this.$auth.user().company_id}_${oldValues.team_id}`
        })
        // Evento emitido para atualizar os detalhes da equipe para os usuários que estão na tela de colsulta
        this.$socket.emit('generalDetailsEvent', {
          data: oldValues,
          details: 'users',
          responseEvent: 'deleteSocketItemDetails',
          room: `teams${this.$auth.user().company_id}`
        })
        // Enviando evento para mostrar alerta na tela do usuário que deixou de ser participante da equipe
        let item = {text: `Não é possível continuar editando esta equipe pois você não é mais um participante.`, user_id: oldValues.user_id, company_id: oldValues.connection_company_id}
        this.$socket.emit('generalEvent', {
          data: item,
          notBroadcast: true,
          responseEvent: 'deleteSocketDetailUser',
          room: `teams${this.$auth.user().company_id}_${oldValues.team_id}`
        })
        // emite um socket para o usuario removido da equipe para ele checar mudanças referente a tarefas
        this.$socket.emit('generalEvent', {
            data: {team_id: oldValues.team_id, text: `você foi removido da equipe ${this.team.id_text}, poderá haver conflito, recarregue a página para obter as mudanças`},
            responseEvent: 'socketSnackbar',
            room: `tasks${oldValues.user_id}`
          })
      }
    },
    computed: {
      itemsNotShow: function () {
        var items = []
        this.items.map((val) => {
          items.push(`${val.user_id}-${val.connection_company_id ? val.connection_company_id : this.$auth.user().company_id}`)
        })
        return items
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'user.id_text'},
          {text: this.translate('table.' + this.entity + '.field.manager'), value: 'manager'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TeamUser.vue